import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/company_user',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (id) {
  return request({
    url: '/company_user/' + id,
    method: 'get'
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/company_user'
  if (data.id) {
    method = 'put'
    url = '/company_user/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function getCompanyUserByAE(data) {
  var method = 'get'
  var url = '/company_user_by_ae/' + data.sae.id
  return request({
    url,
    method,
  })
}

export function getCompanyUserByPre(data) {
  var method = 'get'
  var url = '/company_user_by_pre/' + data.pre.id
  return request({
    url,
    method,
  })
}

export function getCompanyUserBySpm(data) {
  var method = 'get'
  var url = '/company_user_by_spm/' + data.spm.id
  return request({
    url,
    method,
  })
}


export function remove (id) {
  return request({
    url: '/company_user/' + id,
    method: 'delete',
  })
}